import { useState, useCallback, useRef } from 'react';

const defaultExtractTotalPages = (res) => res.data.pagination.totalPages;

const usePaginatedSelect = ({
  fetchFn,
  extractItems,
  formatOption,
  extractTotalPages = defaultExtractTotalPages,
}) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isFetchingRef = useRef(false);
  const generationRef = useRef(0);

  const loadMore = useCallback(() => {
    if (isFetchingRef.current) return;
    if (page !== 1 && page > totalPages) return;

    isFetchingRef.current = true;
    setIsLoading(true);

    const generation = generationRef.current;

    fetchFn(page)
      .then((res) => {
        if (generationRef.current !== generation) return;
        const items = extractItems(res).map(formatOption);
        setData((prev) => [...prev, ...items]);
        setTotalPages(extractTotalPages(res));
        setPage((prev) => prev + 1);
      })
      .finally(() => {
        if (generationRef.current === generation) {
          setIsLoading(false);
          isFetchingRef.current = false;
        }
      });
  }, [fetchFn, extractItems, formatOption, extractTotalPages, page, totalPages]);

  const reset = useCallback(() => {
    generationRef.current += 1;
    isFetchingRef.current = false;
    setData([]);
    setPage(1);
    setTotalPages(0);
  }, []);

  return { data, isLoading, loadMore, reset };
};

export default usePaginatedSelect;
